import React from 'react';
import Skill from './Skill';
import ReactTooltip from 'react-tooltip';

import hakazeimg from '../skillicons/hakaze.png';
import shifuimg from '../skillicons/shifu.png';
import kashaimg from '../skillicons/kasha.png';
import jinpuimg from '../skillicons/jinpu.png';
import gekkoimg from '../skillicons/gekko.png';
import yukikazeimg from '../skillicons/yukikaze.png';
import iaijutsuimg from '../skillicons/iaijutsu.png';
import shintenimg from '../skillicons/shinten.png';
import gurenimg from '../skillicons/guren.png';
import kaitenimg from '../skillicons/kaiten.png';
import hagakureimg from '../skillicons/hagakure.png';
import meikyoimg from '../skillicons/meikyo.png';
import higanbanaimg from '../skillicons/higanbana.png';
import tenkaimg from '../skillicons/tenka.png';
import midareimg from '../skillicons/midare.png';
import infusionimg from '../skillicons/infusion.png';
import diversionimg from '../skillicons/diversion.png';
import fillerimg from '../skillicons/filler.png';

//type 0 = GCD
//type 1 = oGCD

const info = [
    { "id": 0, "name": "Hakaze", "image": hakazeimg, "type": 0, "casttime": 0, "cooldown": 0, "potency": 150, "cpotency": 150, "kenki": 5, "sen": "" },
    { "id": 1, "name": "Shifu", "image": shifuimg, "type": 0, "casttime": 0, "cooldown": 0, "potency": 100, "cpotency": 280, "kenki": 5, "sen": "" },
    { "id": 2, "name": "Kasha", "image": kashaimg, "type": 0, "casttime": 0, "cooldown": 0, "potency": 100, "cpotency": 400, "kenki": 5, "sen": "Ka" },
    { "id": 3, "name": "Jinpu", "image": jinpuimg, "type": 0, "casttime": 0, "cooldown": 0, "potency": 100, "cpotency": 280, "kenki": 5, "sen": "" },
    { "id": 4, "name": "Gekko", "image": gekkoimg, "type": 0, "casttime": 0, "cooldown": 0, "potency": 100, "cpotency": 400, "kenki": 5, "sen": "Getsu" },
    { "id": 5, "name": "Yukikaze", "image": yukikazeimg, "type": 0, "casttime": 0, "cooldown": 0, "potency": 100, "cpotency": 340, "kenki": 5, "sen": "Setsu" },
    { "id": 6, "name": "Iaijutsu", "image": iaijutsuimg, "type": 0, "casttime": 1.8, "cooldown": 0, "potency": 0, "cpotency": 0, "kenki": 0, "sen": "" },
    { "id": 7, "name": "Shinten", "image": shintenimg, "type": 1, "casttime": 0, "cooldown": 1, "potency": 300, "cpotency": 300, "kenki": -25, "sen": "" },
    { "id": 8, "name": "Guren", "image": gurenimg, "type": 1, "casttime": 0, "cooldown": 120, "potency": 800, "cpotency": 800, "kenki": -50, "sen": "" },
    { "id": 9, "name": "Kaiten", "image": kaitenimg, "type": 1, "casttime": 0, "cooldown": 5, "potency": 0, "cpotency": 0, "kenki": -20, "sen": "" },
    { "id": 10, "name": "Hagakure", "image": hagakureimg, "type": 1, "casttime": 0, "cooldown": 40, "potency": 0, "cpotency": 0, "kenki": 0, "sen": "" },
    { "id": 11, "name": "Meikyo", "image": meikyoimg, "type": 1, "casttime": 0, "cooldown": 80, "potency": 0, "cpotency": 0, "kenki": 0, "sen": "" },
    { "id": 12, "name": "Infusion", "image": infusionimg, "type": 1, "casttime": 0, "cooldown": 270, "potency": 0, "cpotency": 0, "kenki": 0, "sen": "" },
    { "id": 13, "name": "Diversion", "image": diversionimg, "type": 1, "casttime": 0, "cooldown": 120, "potency": 0, "cpotency": 0, "kenki": 0, "sen": "" },
    { "id": 14, "name": "Filler", "image": fillerimg, "type": 1, "casttime": 0, "cooldown": 0, "potency": 0, "cpotency": 0, "kenki": 0, "sen": "" },
];

const iconwidth = "48";
const iconheight = "48";

class Simulator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabledata: this.props.data
        };
        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler(event) {
        var buttonValues = event.currentTarget.value.split(',');
        var skillid = parseInt(buttonValues[0]);
        var index = parseInt(buttonValues[1]);

        this.updateTable(skillid, index);
    }

    deleteRow = (index) => {
        var table = this.state.tabledata;
        table.splice(index, 1); //remove row at index
        this.recompute(table);
    }

    render() {
        var data = this.state.tabledata.map((value, key) => {
            return <Skill skill={value} deleteRow={this.deleteRow} />
        });
        return (
            <div class="wrapper">
                <div class="panel-body col-sm-12 main">
                    <div class="col-sm-2">
                        <nav class="navbar navbar-fixed-top" id="sidebar">
                            <div class="sidebar">
                                <div class="sidebar-header">
                                    <span class="subheader">Actions</span>
                                </div>
                                <div class="nav side-bar-nav">
                                    <ul>
                                        <li>
                                            <button data-tip data-for="hakazetip" class="btn btn-secondary" onClick={this.clickHandler} value={[0, this.state.tabledata.length]}><img src={hakazeimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="hakazetip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Hakaze</span>
                                                <br />
                                                Potency: <span class="tgreen">150</span>
                                                <br />
                                                Kenki: <span class="tgreen">+5</span>
                                                <br />
                                                Type: <span class="tblue">Weaponskill (Recast {this.props.gcdtime}s)</span>
                                            </ReactTooltip>
                                            <button data-tip data-for="shifutip" class="btn btn-secondary" onClick={this.clickHandler} value={[1, this.state.tabledata.length]}><img src={shifuimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="shifutip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Shifu</span>
                                                <br />
                                                Potency: <span class="tgreen">100</span>
                                                <br />
                                                Combo Action: <span class="tname">Hakaze</span>
                                                <br />
                                                Combo Kenki: <span class="tgreen">+5</span>
                                                <br />
                                                Combo Potency: <span class="tgreen">280</span>
                                                <br />
                                                Combo Bonus: <span class="tgreen">10% reduced attack delay for 30 seconds</span>
                                                <br />
                                                Type: <span class="tblue">Weaponskill (Recast {this.props.gcdtime}s)</span>
                                            </ReactTooltip>
                                            <button data-tip data-for="kashatip" class="btn btn-secondary" onClick={this.clickHandler} value={[2, this.state.tabledata.length]}><img src={kashaimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="kashatip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Kasha</span>
                                                <br />
                                                Potency: <span class="tgreen">100</span>
                                                <br />
                                                Combo Action: <span class="tname">Shifu</span>
                                                <br />
                                                Combo Kenki: <span class="tgreen">+10</span>
                                                <br />
                                                Combo Potency: <span class="tgreen">400</span>
                                                <br />
                                                Combo Bonus: Grants <span class="tred">Ka</span>
                                                <br />
                                                Type: <span class="tblue">Weaponskill (Recast {this.props.gcdtime}s)</span>
                                            </ReactTooltip>
                                        </li>
                                        <li>
                                            <button data-tip data-for="jinputip" class="btn btn-secondary" onClick={this.clickHandler} value={[3, this.state.tabledata.length]}><img src={jinpuimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="jinputip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Jinpu</span>
                                                <br />
                                                Potency: <span class="tgreen">100</span>
                                                <br />
                                                Combo Action: <span class="tname">Hakaze</span>
                                                <br />
                                                Combo Kenki: <span class="tgreen">+5</span>
                                                <br />
                                                Combo Potency: <span class="tgreen">280</span>
                                                <br />
                                                Combo Bonus: <span class="tgreen">10% increased damage for 30 seconds</span>
                                                <br />
                                                Type: <span class="tblue">Weaponskill (Recast {this.props.gcdtime}s)</span>
                                            </ReactTooltip>
                                            <button data-tip data-for="gekkotip" class="btn btn-secondary" onClick={this.clickHandler} value={[4, this.state.tabledata.length]}><img src={gekkoimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="gekkotip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Gekko</span>
                                                <br />
                                                Potency: <span class="tgreen">100</span>
                                                <br />
                                                Combo Action: <span class="tname">Jinpu</span>
                                                <br />
                                                Combo Kenki: <span class="tgreen">+10</span>
                                                <br />
                                                Combo Potency: <span class="tgreen">400</span>
                                                <br />
                                                Combo Bonus: Grants <span class="tred">Getsu</span>
                                                <br />
                                                Type: <span class="tblue">Weaponskill (Recast {this.props.gcdtime}s)</span>
                                            </ReactTooltip>
                                        </li>
                                        <li>
                                            <button data-tip data-for="yukikazetip" class="btn btn-secondary" onClick={this.clickHandler} value={[5, this.state.tabledata.length]}><img src={yukikazeimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="yukikazetip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Yukikaze</span>
                                                <br />
                                                Potency: <span class="tgreen">100</span>
                                                <br />
                                                Combo Action: <span class="tname">Hakaze</span>
                                                <br />
                                                Combo Kenki: <span class="tgreen">+10</span>
                                                <br />
                                                Combo Potency: <span class="tgreen">340</span>
                                                <br />
                                                Combo Bonus: <span class="tgreen">Reduces target's slashing resistance by 10% for 30 seconds</span>
                                                <br />
                                                Combo Bonus: Grants <span class="tred">Setsu</span>
                                                <br />
                                                Type: <span class="tblue">Weaponskill (Recast {this.props.gcdtime}s)</span>
                                            </ReactTooltip>
                                        </li>
                                        <li>
                                            <button data-tip data-for="iaijutsutip" class="btn btn-secondary" onClick={this.clickHandler} value={[6, this.state.tabledata.length]}><img src={iaijutsuimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="iaijutsutip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Iaijutsu</span>
                                                <br />
                                                Executes a weaponskill depending on current number of Sen stored in the Sen Gauge.
                                            <br />
                                                1 Sen: <span class="tname">Higanbana</span>
                                                <br />
                                                Potency: <span class="tgreen">240</span>
                                                <br />
                                                Additional Effect: <span class="tgreen">Damage over time for 60 seconds</span>
                                                <br />
                                                Additional Effect Potency: <span class="tgreen">35</span>
                                                <br />
                                                2 Sen: <span class="tname">Tenka Goken</span>
                                                <br />
                                                Potency: <span class="tgreen">360</span>
                                                <br />
                                                3 Sen: <span class="tname">Midare Setsugekka</span>
                                                <br />
                                                Potency: <span class="tgreen">720</span>
                                                <br />
                                                Type: <span class="tblue">Weaponskill (Recast {this.props.gcdtime}s) (Cast 1.8s)</span>
                                            </ReactTooltip>
                                        </li>
                                        <li>
                                            <button data-tip data-for="shintentip" class="btn btn-secondary" onClick={this.clickHandler} value={[7, this.state.tabledata.length]}><img src={shintenimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="shintentip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Hissatsu: Shinten</span>
                                                <br />
                                                Potency: <span class="tgreen">300</span>
                                                <br />
                                                Kenki: <span class="tred">-25</span>
                                                <br />
                                                Type: <span class="tblue">Ability (Recast 1s)</span>
                                            </ReactTooltip>
                                            <button data-tip data-for="gurentip" class="btn btn-secondary" onClick={this.clickHandler} value={[8, this.state.tabledata.length]}><img src={gurenimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="gurentip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Hissatsu: Guren</span>
                                                <br />
                                                Potency: <span class="tgreen">800</span>
                                                <br />
                                                Kenki: <span class="tred">-50</span>
                                                <br />
                                                Type: <span class="tblue">Ability (Recast 120s)</span>
                                            </ReactTooltip>
                                        </li>
                                        <li>
                                            <button data-tip data-for="kaitentip" class="btn btn-secondary" onClick={this.clickHandler} value={[9, this.state.tabledata.length]}><img src={kaitenimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="kaitentip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Hissatsu: Kaiten</span>
                                                <br />
                                                Effect: <span class="tgreen">Increases potency of next weaponskill by 50%. Duration: 10 seconds.</span>
                                                <br />
                                                Kenki: <span class="tred">-20</span>
                                                <br />
                                                Type: <span class="tblue">Ability (Recast 5s)</span>
                                            </ReactTooltip>
                                            <button data-tip data-for="hagakuretip" class="btn btn-secondary" onClick={this.clickHandler} value={[10, this.state.tabledata.length]}><img src={hagakureimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="hagakuretip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Hagakure</span>
                                                <br />
                                                Converts Setsu, Getsu, and Ka into Kenki. Each Sen converted increases your Kenki Gauge by 20.
                                            <br />
                                                Type: <span class="tblue">Ability (Recast 40s)</span>
                                            </ReactTooltip>
                                            <button data-tip data-for="meikyotip" class="btn btn-secondary" onClick={this.clickHandler} value={[11, this.state.tabledata.length]}><img src={meikyoimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="meikyotip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">Meikyo Shisui</span>
                                                <br />
                                                Effect: <span class="tgreen">Execute up to 3 weaponskill combos without meeting combo prerequisites. Does not affect Iaijutsu. Duration: 10 seconds.</span>
                                                <br />
                                                Type: <span class="tblue">Ability (Recast 80s)</span>
                                            </ReactTooltip>
                                        </li>
                                        <li>
                                            <button data-tip data-for="infusiontip" class="btn btn-secondary" onClick={this.clickHandler} value={[12, this.state.tabledata.length]}><img src={infusionimg} width={iconwidth} height={iconheight} /></button>
                                            <ReactTooltip id="infusiontip" place="top" type="dark" effect="float" class="tooltip">
                                                <span class="tname">HQ Infusion of Strength</span>
                                                <br />
                                                Effect: <span class="tgreen">Increases strength by 10% (Max 137). Calculated as a 5% potency increase. Duration: 30 seconds.</span>
                                                <br />
                                                Type: <span class="tblue">Item (Recast 270s)</span>
                                            </ReactTooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sidebar-header">
                                    <span class="subheader">Role Actions (Fillers)</span>
                                </div>
                                <ul>
                                    <li>
                                        <button data-tip data-for="diversiontip" class="btn btn-secondary" onClick={this.clickHandler} value={[13, this.state.tabledata.length]}><img src={diversionimg} width={iconwidth} height={iconheight} /></button>
                                        <ReactTooltip id="diversiontip" place="top" type="dark" effect="float" class="tooltip">
                                            <span class="tname">Diversion</span>
                                            <br />
                                            Effect: <span class="tgreen">Reduces enmity generation. Duration: 15 seconds.</span>
                                            <br />
                                            Type: <span class="tblue">Ability (Recast 120s)</span>
                                        </ReactTooltip>
                                    </li>
                                    <li>
                                        <button data-tip data-for="fillertip" class="btn btn-secondary" onClick={this.clickHandler} value={[14, this.state.tabledata.length]}><img src={fillerimg} width={iconwidth} height={iconheight} /></button>
                                        <ReactTooltip id="fillertip" place="top" type="dark" effect="float" class="tooltip">
                                            <span class="tname">Filler</span>
                                            <br />
                                            Filler action. Use this to delay actions. Calculated as a generic oGCD ability.
                                        <br />
                                            Type: <span class="tblue">Ability (Recast {this.props.ogcdtime})</span>
                                        </ReactTooltip>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <div id="simulator" class="col-sm-10">
                        <div class="tableheader">
                            <span class="col-sm-5">
                                <span class="col-sm-2">
                                    &#8203;
                                </span>
                                <span class="col-sm-2">
                                    Time
                        </span>
                                <span class="col-sm-2">
                                    Icon
                                </span>
                                <span class="col-sm-2">
                                    Name
                                </span>
                                <span class="col-sm-2">
                                    Potency
                                </span>
                                <span class="col-sm-2">
                                    Kenki
                                </span>
                            </span>
                            <span class="col-sm-1">
                                Sen
                        </span>
                            <span class="col-sm-1">
                                Dots
                        </span>
                            <span class="col-sm-3">
                                Buffs
                        </span>
                            <span class="col-sm-2">
                                Cooldowns
                        </span>
                        </div>
                        <ul>
                            {data}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    recompute(t) {
        var currentTable = t;
        var newTable = [];
        for (var i = 0; i < currentTable.length; i++) {
            if (i === 0) { //initial row
                var skillinfo = info[currentTable[i].id];
                var rowToInsert = {
                    "id": skillinfo.id,
                    "name": skillinfo.name,
                    "image": skillinfo.image,
                    "type": skillinfo.type,
                    "casttime": skillinfo.casttime,
                    "cooldown": skillinfo.cooldown,
                    "potency": skillinfo.potency,
                    "time": 0,
                    "combo": 0,
                    "kenki": skillinfo.kenki, //current accumulated kenki
                    "sen": { "Ka": 0, "Getsu": 0, "Setsu": 0 },
                    "meikyo": 0, //1 if meikyo shisui is active
                    "dotpotency": 0, //accumulated dot potency
                    "tpotency": skillinfo.potency, //accumulated non-dot potency
                    "prevGCDName": skillinfo.type ? "" : skillinfo.name, //null if oGCD, name if GCD
                    "prevGCDTime": 0, //time of the last gcd skill used
                    "prevGCDspeedmod": 0, //speed modifier of last gcd skill used
                    "prevGCDspeedbuffduration": 0, //duration of speed modifier of last gcd skill used
                    "errorflag": skillinfo.kenki > 0 ? false : true, //error flag
                    "position": 0, //position in array
                };
                rowToInsert["dots"] = this.updateDots(rowToInsert, null, 1).dotarray;
                rowToInsert["buffs"] = this.updateBuffs(rowToInsert, null);
                if (rowToInsert.buffs.length > 0) { //if the first skill was a buff
                    switch (rowToInsert.buffs[0].name) {
                        case "meikyoshisuibuff":
                            rowToInsert.meikyo = 1;
                            break;
                        default:
                            break;
                    }
                }
                rowToInsert["cooldowns"] = this.updateCooldowns(rowToInsert, null);

                newTable.push(rowToInsert);
            }
            else { //compute values for remaining rows
                var prevSkill = newTable[i - 1];
                var currentSkillInfo = info[currentTable[i].id];
                var rowToInsert = this.buildRow(currentSkillInfo, prevSkill);

                if (i === currentTable.length - 1) { //on the last row compute accumulated dot potency for active dots
                    for (var j = 0; j < rowToInsert.dots.length; j++) {
                        rowToInsert.dotpotency += Math.floor((rowToInsert.dots[j].initialduration - rowToInsert.dots[j].duration) / 3) * rowToInsert.dots[j].tickpotency;
                    }
                }

                rowToInsert["position"] = i; //set position

                newTable.push(rowToInsert);
            }
        }
        this.setState({
            tabledata: newTable
        }, () => {
            this.props.updateparent(this.state.tabledata);
        });
    }

    updateTable(skillid, index) { //insert or drag and drop
        var currentTable = this.state.tabledata;
        var rowToInsert = {
            "id": skillid,
        }
        currentTable.splice(index, 0, rowToInsert);
        this.recompute(currentTable);
    }

    buildRow(currentSkillInfo, prevSkill) {
        var skill = {
            "id": currentSkillInfo.id,
            "name": currentSkillInfo.name,
            "image": currentSkillInfo.image,
            "type": currentSkillInfo.type,
        };
        var comboflag = 0;
        var potency = currentSkillInfo.potency;
        var kenki = currentSkillInfo.kenki;
        var sen = JSON.parse(JSON.stringify(prevSkill.sen)); //deep copy


        //check combos to determine values
        if (prevSkill.meikyo === 1) { //if meikyo shisui is active
            switch (currentSkillInfo.name) {
                case "Shifu":
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 5;
                    break;
                case "Jinpu":
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 5;
                    break;
                case "Yukikaze":
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 10;
                    sen.Setsu = 1;
                    break;
                case "Kasha":
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 10;
                    sen.Ka = 1;
                    break;
                case "Gekko":
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 10;
                    sen.Getsu = 1;
                    break;
                default:
                    break;
            }
        }
        else {
            if (prevSkill.prevGCDName === "Hakaze") {
                if (currentSkillInfo.name === "Shifu") {
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 5;
                }
                else if (currentSkillInfo.name === "Jinpu") {
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 5;
                }
                else if (currentSkillInfo.name === "Yukikaze") {
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 10;
                    sen.Setsu = 1;
                }
            }

            if (prevSkill.prevGCDName === "Shifu") {
                if (currentSkillInfo.name === "Kasha" && prevSkill.combo === 1) {
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 10;
                    sen.Ka = 1;
                }
            }

            if (prevSkill.prevGCDName === "Jinpu") {
                if (currentSkillInfo.name === "Gekko" && prevSkill.combo === 1) {
                    comboflag = 1;
                    potency = currentSkillInfo.cpotency;
                    kenki = 10;
                    sen.Getsu = 1;
                }
            }
        }

        if (currentSkillInfo.name === "Iaijutsu") { //calculate Iaijutsu
            var senCount = 0;
            if (sen.Ka === 1) {
                senCount += 1;
            }
            if (sen.Getsu === 1) {
                senCount += 1;
            }
            if (sen.Setsu === 1) {
                senCount += 1;
            }
            sen.Ka = 0;
            sen.Getsu = 0;
            sen.Setsu = 0;
            switch (senCount) {
                case 3:
                    skill["name"] = "Midare";
                    potency = 720;
                    break;
                case 2:
                    skill["name"] = "Tenka";
                    potency = 360;
                    break;
                case 1:
                    skill["name"] = "Higanbana";
                    potency = 240;
                    break;
                default:
                    break;
            }
        }

        if (currentSkillInfo.name === "Hagakure") { //calculate Hagakure
            var senCount = 0;
            if (sen.Ka === 1) {
                senCount += 1;
            }
            if (sen.Getsu === 1) {
                senCount += 1;
            }
            if (sen.Setsu === 1) {
                senCount += 1;
            }
            sen.Ka = 0;
            sen.Getsu = 0;
            sen.Setsu = 0;
            switch (senCount) {
                case 3:
                    kenki = 60;
                    break;
                case 2:
                    kenki = 40;
                    break;
                case 1:
                    kenki = 20;
                    break;
                default:
                    break;
            }
        }

        //process attack speed buffs
        //speedmod = 2: case where last weaponskill used did not have shifu buff and shifu is currently active (do not calculate shifu buff)
        //speedmod = 1: case where last weaponskill used did have shifu buff and shifu is currently active (do calculate shifu buff)
        //speedmod = 0: case where shifu is not currently active
        var gcd = this.props.gcdtime;
        if (prevSkill.prevGCDspeedmod === 1) {
            gcd = gcd * 0.9;
        }
        if (skill.type === 0) {
            skill["prevGCDspeedmod"] = 0;
            skill["prevGCDspeedbuffduration"] = 0;
        }
        else {
            skill["prevGCDspeedmod"] = prevSkill.prevGCDspeedmod;
            skill["prevGCDspeedbuffduration"] = prevSkill.prevGCDspeedbuffduration;
        }

        skill["kenki"] = kenki + prevSkill.kenki > 100 ? 100 : kenki + prevSkill.kenki;
        skill["sen"] = sen;
        skill["cooldown"] = currentSkillInfo.cooldown;
        skill["casttime"] = currentSkillInfo.casttime;
        skill["time"] = this.calculateTime(currentSkillInfo, prevSkill, gcd); //determine time      

        //determine previous GCD time and name
        if (skill.type === 0) { //GCD skill
            skill["prevGCDTime"] = skill.time;
            if (skill.name === "Iaijutsu" || skill.name === "Higanbana" || skill.name === "Tenka" || skill.name === "Midare") { //ignore combo for Iaijutsu
                skill["prevGCDName"] = prevSkill.prevGCDName;
                skill["combo"] = prevSkill.combo;
            }
            else {
                skill["prevGCDName"] = skill.name;
                skill["combo"] = comboflag;
            }
        }
        else { //non-GCD skill
            skill["prevGCDTime"] = prevSkill.prevGCDTime;
            skill["prevGCDName"] = prevSkill.prevGCDName;
            skill["combo"] = prevSkill.combo;
        }

        //update buffs
        skill["buffs"] = this.updateBuffs(skill, prevSkill);

        //update cooldowns
        skill["cooldowns"] = this.updateCooldowns(skill, prevSkill);

        //process buffs
        var buffmultiplier = 1;
        var slashingmultiplier = 1;
        var kaitenmultiplier = 1;
        var potmultiplier = 1;
        var i = skill.buffs.length;
        while (i--) {
            switch (skill.buffs[i].name) {
                case "shifubuff":
                    if (skill.type === 0) {
                        if (prevSkill.prevGCDspeedmod === 0) {
                            skill["prevGCDspeedmod"] = 2; //case where last weaponskill used did not have shifu buff and shifu is currently active
                            skill["prevGCDspeedbuffduration"] = skill.buffs[i].duration;
                        }
                        else if (prevSkill.prevGCDspeedmod === 1 && prevSkill.prevGCDspeedbuffduration < gcd) {
                            skill["prevGCDspeedmod"] = 2;
                            skill["prevGCDspeedbuffduration"] = skill.buffs[i].duration;
                        }
                        else {
                            skill["prevGCDspeedmod"] = 1; //case where last weaponskill used did have shifu buff and shifu is currently active
                            skill["prevGCDspeedbuffduration"] = skill.buffs[i].duration;
                        }
                    }
                    break;
                case "jinpubuff":
                    buffmultiplier = buffmultiplier * 1.1;
                    break;
                case "yukikazedebuff":
                    slashingmultiplier = slashingmultiplier * 1.1;
                    break;
                case "kaitenbuff":
                    if (skill.type === 0) { //only affects GCD skills
                        kaitenmultiplier = kaitenmultiplier * 1.5;
                        skill.buffs.splice(i, 1); //remove Kaiten buff if used on gcd
                    }
                    break;
                case "meikyoshisuibuff":
                    skill.meikyo = 1;
                    break;
                case "infusionbuff":
                    potmultiplier = potmultiplier * 1.05;
                default:
                    break;
            }
        }

        var multiplier = buffmultiplier * slashingmultiplier * kaitenmultiplier * potmultiplier;
        var dotmultiplier = buffmultiplier * kaitenmultiplier * potmultiplier; // dots not affected by slashing debuff

        skill["potency"] = potency * multiplier;
        skill["tpotency"] = prevSkill.tpotency + potency * multiplier;

        //update dots
        var dotinfo = this.updateDots(skill, prevSkill, dotmultiplier);
        skill["dots"] = dotinfo.dotarray;
        skill["dotpotency"] = dotinfo.dotpotency + prevSkill.dotpotency;

        //check for errors
        skill["errorflag"] = this.updateErrors(skill);

        return skill;
    }

    calculateTime(currentSkillInfo, prevSkill, gcdtime) { //pass in gcdtime to accomodate speed buffs
        if (currentSkillInfo.type === 0) { //gcd
            if (prevSkill.prevGCDTime === 0) { //initial gcd skill
                if (prevSkill.type === 0) {
                    return prevSkill.time + gcdtime;
                }
                else if (prevSkill.type === 1) {
                    return prevSkill.time + this.props.ogcdtime;
                }
            }

            if ((prevSkill.time + this.props.ogcdtime) - prevSkill.prevGCDTime > gcdtime) { //clipping
                return prevSkill.time + this.props.ogcdtime;
            }
            else if (prevSkill.casttime > 0) { //following a casted skill
                var speedratio = gcdtime / 2.5;
                if ((prevSkill.time + prevSkill.casttime * speedratio) - prevSkill.prevGCDTime > gcdtime) { //clipping
                    return prevSkill.time + prevSkill.casttime * speedratio;
                }
                else {
                    return prevSkill.prevGCDTime + gcdtime;
                }
            }
            else {
                return prevSkill.prevGCDTime + gcdtime;
            }
        }
        else if (currentSkillInfo.type === 1) { //ogcd
            if (prevSkill.casttime > 0) { //following a casted skill
                var speedratio = gcdtime / 2.5
                return prevSkill.time + prevSkill.casttime * speedratio;
            }
            else {
                return prevSkill.time + this.props.ogcdtime;
            }
        }
        else { //external buffs/debuffs
            return prevSkill.time + 0.01;
        }
    }

    updateErrors(currentSkill) {
        var errorflag = false;
        if (currentSkill.kenki < 0) {
            errorflag = true;
        }

        for (var i = 0; i < currentSkill.cooldowns.length; i++) {
            if (currentSkill.cooldowns[i].error !== "") {
                errorflag = true;
            }
        }
        return errorflag;
    }

    updateCooldowns(currentSkill, prevSkill) {
        var currentCooldowns = [];
        if (prevSkill !== null) { //not initial row
            currentCooldowns = JSON.parse(JSON.stringify(prevSkill.cooldowns)); //deep copy

            //tick down existing cooldowns
            var i = currentCooldowns.length;
            while (i--) {
                currentCooldowns[i].duration -= (currentSkill.time - prevSkill.time);
                if (currentCooldowns[i].duration <= 0) {
                    currentCooldowns.splice(i, 1); //remove cooldown when duration expires
                }
                else {
                    currentCooldowns[i].error = ""; //remove error message
                }
            }
        }

        //insert new cooldowns
        if (currentSkill.cooldown > 0) {
            currentCooldowns = this.insertCooldown(currentCooldowns, { "name": currentSkill.name, "image": currentSkill.image, "duration": currentSkill.cooldown, "error": "" });
        }

        return currentCooldowns;
    }

    insertCooldown(currentCooldowns, cooldown) {
        var updatedCooldowns = currentCooldowns;
        var doesCooldownExist = false;
        for (var i = 0; i < updatedCooldowns.length; i++) {
            if (updatedCooldowns[i].name === cooldown.name) { //if the cooldown already exists
                updatedCooldowns[i].error = updatedCooldowns[i].name + " not ready yet.";
                doesCooldownExist = true;
            }
            else {
                updatedCooldowns[i].error = "";
            }
        }

        if (doesCooldownExist === false) { //insert new cooldown
            updatedCooldowns.push(cooldown);
        }

        return updatedCooldowns;
    }

    updateBuffs(currentSkill, prevSkill) {
        var currentBuffs = [];
        if (prevSkill !== null) { //not initial row, process combo buffs
            currentBuffs = JSON.parse(JSON.stringify(prevSkill.buffs)); //deep copy

            //tick down existing buffs
            var i = currentBuffs.length;
            while (i--) {
                currentBuffs[i].duration -= (currentSkill.time - prevSkill.time);
                if (currentBuffs[i].name === "meikyoshisuibuff") { //reduce meikyo shisui stacks if attack is a GCD ability (excluding Iaijutsu)
                    if (currentSkill.type === 0 && currentSkill.name !== "Iaijutsu" && currentSkill.name !== "Higanbana" && currentSkill.name !== "Tenka" && currentSkill.name !== "Midare") {
                        currentBuffs[i].stacks -= 1;
                    }
                }
                if (currentBuffs[i].duration <= 0 || currentBuffs[i].stacks === 0) { //remove buff when duration expired or out of uses
                    currentBuffs.splice(i, 1);
                }
            }

            //insert new buffs
            if (prevSkill.meikyo === 1) { //if meikyo shisui is active
                if (currentSkill.name === "Shifu") {
                    currentBuffs = this.insertBuff(currentBuffs, { "name": "shifubuff", "image": shifuimg, "duration": 30, "type": "buff", "stacks": 1 });
                }
                else if (currentSkill.name === "Jinpu") {
                    currentBuffs = this.insertBuff(currentBuffs, { "name": "jinpubuff", "image": jinpuimg, "duration": 30, "type": "buff", "stacks": 1 });
                }
                else if (currentSkill.name === "Yukikaze") {
                    currentBuffs = this.insertBuff(currentBuffs, { "name": "yukikazedebuff", "image": yukikazeimg, "duration": 30, "type": "debuff", "stacks": 1 });
                }
            }
            else {
                if (prevSkill.prevGCDName === "Hakaze") {
                    if (currentSkill.name === "Shifu") {
                        currentBuffs = this.insertBuff(currentBuffs, { "name": "shifubuff", "image": shifuimg, "duration": 30, "type": "buff", "stacks": 1 });
                    }
                    else if (currentSkill.name === "Jinpu") {
                        currentBuffs = this.insertBuff(currentBuffs, { "name": "jinpubuff", "image": jinpuimg, "duration": 30, "type": "buff", "stacks": 1 });
                    }
                    else if (currentSkill.name === "Yukikaze") {
                        currentBuffs = this.insertBuff(currentBuffs, { "name": "yukikazedebuff", "image": yukikazeimg, "duration": 30, "type": "debuff", "stacks": 1 });
                    }
                }
            }
        }

        //process non combo buffs
        if (currentSkill.name === "Kaiten") {
            currentBuffs = this.insertBuff(currentBuffs, { "name": "kaitenbuff", "image": kaitenimg, "duration": 10, "type": "buff", "stacks": 1 });
        }

        if (currentSkill.name === "Meikyo") {
            currentBuffs = this.insertBuff(currentBuffs, { "name": "meikyoshisuibuff", "image": meikyoimg, "duration": 10, "type": "buff", "stacks": 3 });
        }

        if (currentSkill.name === "Infusion") {
            currentBuffs = this.insertBuff(currentBuffs, { "name": "infusionbuff", "image": infusionimg, "duration": 30, "type": "buff", "stacks": 1 });
        }

        if (currentSkill.name === "Diversion") {
            currentBuffs = this.insertBuff(currentBuffs, { "name": "diversionbuff", "image": diversionimg, "duration": 15, "type": "buff", "stacks": 1 });
        }
        return currentBuffs;
    }

    insertBuff(currentBuffs, buff) {
        var updatedBuffs = currentBuffs;
        var doesBuffExist = false;
        for (var i = 0; i < updatedBuffs.length; i++) {
            if (updatedBuffs[i].name === buff.name) { //if the buff already exists
                updatedBuffs[i].duration = buff.duration; //set duration to full
                doesBuffExist = true;
            }
        }
        if (doesBuffExist === false) {
            updatedBuffs.push(buff);
        }

        return updatedBuffs;
    }

    updateDots(currentSkill, prevSkill, multiplier) {
        var currentDots = [];
        var dotpotency = 0;
        if (prevSkill !== null) { //not initial row, tick down existing dots
            currentDots = JSON.parse(JSON.stringify(prevSkill.dots)); //deep copy

            //tick down existing dots
            var i = currentDots.length;
            while (i--) {
                currentDots[i].duration -= (currentSkill.time - prevSkill.time);
                if (currentDots[i].duration <= 0) { //if dot is expiring, update accumulated dot damage
                    dotpotency += currentDots[i].ticks * currentDots[i].tickpotency;
                    currentDots.splice(i, 1); //remove dot when duration expires
                }
            }
        }

        if (currentSkill.name === "Higanbana") {
            var doesDotExist = false;
            for (var i = 0; i < currentDots.length; i++) {
                if (currentDots[i].skillname === currentSkill.name) { //if dot exists
                    dotpotency += Math.floor((currentDots[i].initialduration - currentDots[i].duration) / 3) * currentDots[i].tickpotency; //update accumulated dot potency
                    currentDots[i].duration = currentDots[i].initialduration; // set duration to full
                    currentDots[i].tickpotency = 35 * multiplier; //update tick potency with multipliers
                    doesDotExist = true;
                }
            }

            if (doesDotExist === false) {
                currentDots.push({ "skillname": "Higanbana", "image": higanbanaimg, "duration": 60, "initialduration": 60, "ticks": 20, "tickpotency": 35 * multiplier });
            }
        }

        return { "dotarray": currentDots, "dotpotency": dotpotency };
    }
}

export default Simulator;


// WEBPACK FOOTER //
// ./src/components/Simulator.js